import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const skillAchievementApi = createApi({
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getCertificates: builder.query({
            query: () => ({
                url: `/student/certificates`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllSkillCategory: builder.query({
            query: () => ({
                url: `/student/skills/dropdown`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addCertificates: builder.mutation({
            query: ({ requestDTO, certificate }) => {
                return {
                    url: '/student/certificates/add',
                    method: 'POST',
                    body: buildFormData({ requestDTO, certificate })
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateCertificates: builder.mutation({
            query: ({ requestDTO, certificate }) => {
                return {
                    url: '/student/certificates/update',
                    method: 'POST',
                    body: buildFormData({ requestDTO, certificate })
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getCertificatesById: builder.query({
            query: (certificateId) => ({
                url: `/student/certificates/${certificateId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteCertificate: builder.mutation({
            query: (certificateId) => ({
                url: `/student/certificates/delete?certificateId=${certificateId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getStudentCertificatesRecord: builder.query({
            query: (params) => ({
                url: `/student/certificates/record`,
                method: 'GET',
                params
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useAddCertificatesMutation, useUpdateCertificatesMutation,
    useLazyGetCertificatesQuery, useLazyGetAllSkillCategoryQuery,
    useLazyGetCertificatesByIdQuery,
    useDeleteCertificateMutation,
    useLazyGetStudentCertificatesRecordQuery,
    useGetStudentCertificatesRecordQuery
} = skillAchievementApi;

export default skillAchievementApi;
